export default __webpack_public_path__ + "static/media/MICE-incentives-dt@2x.8e4bb0bc.jpg";